var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.UserLayer = new Class({
    Extends: OCS.Viewer.Classes.VectorLayer,
    Implements: [new Class(OCS.Viewer.Interfaces.LayerLegend)],
    debug: false,
    class_name: "UserLayer",
    user_layer_popup: null,
    allow_mouse_select: true,
    allow_mouse_over: true,
    has_overlay: true,
    overlay: null,
    mouse_position_event_key: null,
    mouse_location_padding: [25, 60, 25, 30], // [minx, miny, maxx, maxy]
    create: function () {
        var layer_ops = {};
        var source = this.get_source();
        if (source) {
            layer_ops.source = source;
        }
        var vector_layer = new ol.layer.Image(layer_ops);
        this.set_layer(vector_layer);
        return vector_layer;
    },
    mouse_over: function (mouse_position, resolution) {
        if (!this.allow_mouse_over) {
            return;
        }
        var source = this.get_source().getSource();
        if (source) {
            var search_extent = [mouse_position[0] - (resolution * this.mouse_location_padding[0]), mouse_position[1] - (resolution * this.mouse_location_padding[1]), mouse_position[0] + (resolution * this.mouse_location_padding[2]), mouse_position[1] + (resolution * this.mouse_location_padding[3])]; // [minx, miny, maxx, maxy]
            var features = source.getFeaturesInExtent(search_extent);
            if (features.length && mouse_position && mouse_position.length === 2) {
                this.fireEvent(OCS.Viewer.Config.events.RENDER_HTML, ['user_layer_popup', this.build_list_html_ops(features), this]);
                if (this.overlay.getElement() && features.length) {
                    this.overlay.setPosition(mouse_position);
                }
            } else {
                this.fireEvent(OCS.Viewer.Config.events.RENDER_HTML, ['user_layer_popup', this.build_list_html_ops(features), this]);
            }
        }
    },
    mouse_click: function (mouse_position, resolution) {
        if (!this.allow_mouse_select) {
            return;
        }
        var source = this.get_source().getSource();
        if (source) {
            // Determine the number of features at this position
            this.mouse_over(mouse_position, resolution);

            var search_extent = [mouse_position[0] - (resolution * this.mouse_location_padding[0]), mouse_position[1] - (resolution * this.mouse_location_padding[1]), mouse_position[0] + (resolution * this.mouse_location_padding[2]), mouse_position[1] + (resolution * this.mouse_location_padding[3])]; // [minx, miny, maxx, maxy]
            var features = source.getFeaturesInExtent(search_extent);
            if (features.length) {
                this.allow_mouse_over = false;
                this.set_overlay_vis();
            } else {
                this.allow_mouse_over = true;
                this.set_overlay_vis();
            }
        }
    },
    build_list_html_ops: function (features) {
        var html_ops = {features: []};
        var i = 0;
        if (features.length) {
            for (i = 0; i < features.length; i++) {
                html_ops.features.push(features[i].getProperties());
            }
        } else {
            html_ops.is_hidden = true;
        }
        return html_ops;
    },
    on_overlay_close: function () {
        this.allow_mouse_over = true;
        this.set_overlay_vis();
    },
    set_overlay_vis: function () {
        if (this.overlay) {
            var ovr_element = this.overlay.getElement();
            if (ovr_element) {
                var element = jQuery('.user_list_delete', jQuery(ovr_element));
                if (!this.allow_mouse_over) {
                    element.removeClass('hidden');
                } else {
                    element.addClass('hidden');
                }
            }
        }
    },
    set_html: function (elements) {
        if (this.overlay) {
            elements.getElement('.close_text_list').addEvent('click', this.on_overlay_close.bind(this));
            var el = elements[0];
            this.overlay.setElement(el);
            if (!this.allow_mouse_over) {
                el.getElements('.user_list_delete').removeClass('hidden');
            }
        }
    },
    set_source_obj: function (source) {
        // Verify the incoming source is what we are expecting
        if (source && source.class_type === "Source") {
            this.source_obj = source;
            this.set_layer_source();
        }
    },
    set_overlay: function (ovrly) {
        this.overlay = ovrly;
    },
    is_static: function () {
        return true;
    }
});
